'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _PropertyBag2 = require('./PropertyBag');

var _PropertyBag3 = _interopRequireDefault(_PropertyBag2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A simple property bag that exposes accessors for the most common properties of this application instance
 *
 * @class
 * @extends {PropertyBag}
 */
var InstanceProps = function (_PropertyBag) {
  (0, _inherits3.default)(InstanceProps, _PropertyBag);

  /**
   * @param {String} appId the id of this instance's application
   * @param {String} appTitle the title of this instance's application
   * @param {String} appPackageName the package name (from package.json) f
   * @param {String} instanceId
   * @param {...*} [otherProps] experimental or undocumented props
   */
  function InstanceProps(_ref) {
    var appId = _ref.appId,
        appTitle = _ref.appTitle,
        appPackageName = _ref.appPackageName,
        instanceId = _ref.instanceId,
        otherProps = (0, _objectWithoutProperties3.default)(_ref, ['appId', 'appTitle', 'appPackageName', 'instanceId']);
    (0, _classCallCheck3.default)(this, InstanceProps);
    return (0, _possibleConstructorReturn3.default)(this, (InstanceProps.__proto__ || (0, _getPrototypeOf2.default)(InstanceProps)).call(this, (0, _extends3.default)({ appId: appId, appTitle: appTitle, appPackageName: appPackageName, instanceId: instanceId }, otherProps)));
  }

  /**
   * @public
   * @readonly
   *
   * @type {String}
   */


  (0, _createClass3.default)(InstanceProps, [{
    key: 'appId',
    get: function get() {
      return this.props.appId;
    }

    /**
     * @public
     * @readonly
     *
     * @type {String}
     */

  }, {
    key: 'appTitle',
    get: function get() {
      return this.props.appTitle;
    }

    /**
     * @public
     * @readonly
     *
     * @type {String}
     */

  }, {
    key: 'appPackageName',
    get: function get() {
      return this.props.appPackageName;
    }

    /**
     * @public
     * @readonly
     *
     * @type {String}
     */

  }, {
    key: 'instanceId',
    get: function get() {
      return this.props.instanceId;
    }
  }]);
  return InstanceProps;
}(_PropertyBag3.default);

exports.default = InstanceProps;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Core/InstanceProps.js
// module id = 330
// module chunks = 0